export const addCheckDate = (checkDate) => {
  return {
    type: "ADD_CHECK_DATE",
    payload: checkDate,
  };
};
